import {
  FETCH_FACILITIES,
  RESET_SEARCH,
  FETCH_FACILITY,
  // FETCH_RCRAWASTECODEMATRIX,
} from "../actions/types";

const initialState = {
  results: [],
  searchResults: [],
  keyword: "",
  isFetching: false,
  options: {
    total_records: 0,
  },
  filters: {
    keyword: "",
    epa_id: false,
    facility: false,
    street: "",
    city: "",
    active: "both",
    multicounty: [],
    zipCode: "",
    sort: "EPA_ID",
    sortBy: "ASC",
    addressType: "physical",
    manifestType: "all",
    epaIdCategory: "all",
    epaIdType: "all",
    type: "all",
    page: 1,
    pageSize: 10,
    issueFDate: "",
    issueTDate: "",
    total_records: 0,
  },
};

const resetState = {
  results: [],
  searchResults: [],
  keyword: "",
  isFetching: false,
  options: {
    total_records: 0,
  },
  filters: {
    keyword: "",
    epa_id: false,
    facility: false,
    street: "",
    city: "",
    active: "both",
    multicounty: [],
    zipCode: "",
    sort: "EPA_ID",
    sortBy: "ASC",
    addressType: "physical",
    manifestType: "all",
    epaIdCategory: "all",
    epaIdType: "all",
    type: "all",
    page: 1,
    pageSize: 10,
    issueFDate: "",
    issueTDate: "",
    total_records: 0,
  },
};;

export default function (state = initialState, actions) {
  switch (actions.type) {
    case FETCH_FACILITIES:
      return {
        ...state,
        searchResults: actions.payload,
        isFetching: actions.isFetching,
        options: actions.options,
        filters: actions.filters,
        keyword: actions.keyword,
      };
    case RESET_SEARCH:
      return {
        ...state,
        //searchResults: actions.payload,
        isFetching: actions.isFetching,
        //options: resetState.options,
        filters: resetState.filters,
        keyword: resetState.keyword
      };

    case FETCH_FACILITY:
      return {
        ...state,
        facility: actions.payload,
        isFetching: actions.isFetching,
      };
    // case FETCH_RCRAWASTECODEMATRIX:
    //     return{
    //         ...state,
    //         rcrawastecodematrix: actions.payload,
    //         isFetching: actions.isFetching
    //     }
    default:
      return state;
  }
}
